import { LiveWatermarkJson } from '@/components/LiveWatermark/utils';

export interface flagThemeJson {
  backgroundUrl: string;
  bgImage: string;
  fullIconUrl: string;
  leftColor: string;
  rightBottomImage: string;
  rightColor: string;
  shadowUrl: string;
  simpleIconUrl: string;
}

export interface authInfoJson {
  flagTheme: flagThemeJson;
  name: string;
}

export interface competition_listJson {
  live_no: string;
  live_title: string;
}
export interface shareJson {
  icon: string;
  sub_title: string;
  title: string;
  url: string;
}

export interface contentLimitJson {
  time: string;
  count: string;
}

export interface bulletSettingJson {
  content_limit: contentLimitJson;
  count_limit: contentLimitJson;
  mute_time: string;
  time_limit: string;
}

export interface myGuardJson {
  type: number;
  level: number;
  privilege?: number;
}

export interface guardGiftJson {
  icon: string;
  id: number;
  name: string;
  num: number;
}

export interface liveDetailJson {
  // agora_token: string;
  // auth_info: any;
  box_entry_switch: number;
  // channel_name: number;
  cover: string;
  fans_num: number;
  game_appid: number;
  game_id: number;
  game_logo: string;
  game_name: string;
  data_type: string;
  /** 是否赛事直播：0-否，非 0-是（与 data_type 组合判断直播间类型） */
  is_competition?: number;
  competition_list: competition_listJson[];
  game_server: number;
  game_type: string;
  // gift_combo_ts: number;
  head_img: string;
  // hot_detail: any
  hx_room_id: number;
  is_follow: boolean;
  is_living: number;
  is_show_game: number;
  live_bulletin: string;
  live_hot: number;
  // live_list: any
  live_no: number;
  live_title: string;
  mask_switch: string;
  // mask_url: string;
  auth_info: authInfoJson;
  my_auth_info: authInfoJson;
  nickname: string;
  notice_time: number;
  pull_url: string;
  pull_url_flv: string;
  pull_url_m3u8: string;
  server_name: string;
  // share_bt_switch: number;
  // share_url: string;
  // tab_list: any;
  // tag: number;
  tag_name: string;
  uid: number;
  // version: number;
  // version_name: string;
  share: shareJson;
  bullet_setting?: bulletSettingJson;
  bShowChatBt?: boolean;
  live_mode?: string;
  provider?: string;
  rtc_token?: string;
  time?: number;
  guard_entrance?: any;
  my_guard?: myGuardJson;
  guardRule?: string;
  guard_gift?: guardGiftJson;
  show_live_no?: string;
  user_96show?: ShowUserInfo;
  svip_effect?: SvipInfo;
  watermark?: LiveWatermarkJson;
  /** 96秀直播icon */
  showMark?: ShowMarkJson;
  /** 多人 PK 连线 id；接口可能不返回，存在且非 0 表示当前在多人 PK/连线中 */
  pk_connect_id?: number;
}

/** 用户标签枚举 */
export enum UserTagEnum {
  /** 回流用户 */
  RETURNING = 'RETURNING',
  /** 核心用户 */
  CORE = 'CORE',
  /** 潜力用户 */
  POTENTIAL = 'POTENTIAL',
  /** 付费用户 */
  PAID = 'PAID',
  /** 普通用户 */
  NORMAL = 'NORMAL',
  /** 新用户 */
  NEW = 'NEW'
}

export interface ShowMarkJson {
  url?: string;
  show?: boolean;
}

export interface SvipInfo {
  barrageEffectFlag: boolean;
  barrageMedalFlag: boolean;
  levelLogoUrlFlag: boolean;
  svipLevel: number;
  levelLogoUrl: string;
  welcomeFlag: boolean;
}

export interface ShowUserInfo {
  id?: number;
  nick_name?: number;
  head_img?: string;
  show_user_id?: string;
}

export interface msgBanInfoState {
  isBanMsg: boolean;
  isBanMsgTime: number;
  isBanMsgStr: string;
}

export interface infoCardDetailJson {
  userUid: number;
  isModalVisible: boolean;
  liveUid: number;
  type: number;
}

export interface liveModalInfoJson {
  width?: number;
  visible: boolean;
  content: string;
  descContent?: string;
  cancelText?: string;
  saveText?: string;
  zIndex?: number;
  isSave?: boolean;
  returnInfo?: any;
  blackTextOne?: string;
  blackTextTwo?: string;
  centered?: boolean;
}

export interface liveModalInfoPropsJson {
  liveModalInfo?: liveModalInfoJson;
  returnLiveBaseEvent?: (info?: any) => void;
}

export interface livePlayerProps {
  info: livePlayerJson;
}

export interface livePlayerJson {
  roomId: number;
  liveUrl: string;
  isMaskSwitch: string;
  cover: string;
  isCompetition?: number;
  isRecom?: boolean;
  banSpeak?: boolean;
  roomDetail?: liveDetailJson;
}

export interface playerInfo {
  playing: boolean;
  volume: number;
  muted: boolean;
}
